import { dataLayerHomepage } from "@/data-layer/services/page";
import { dataLayerHPBannerImpression, dataLayerHPBannerClick } from "@/data-layer/services/promotions";

function extractCreativeFromBanner(banner: Element): string {
    const creativeElements = banner.querySelectorAll(
        ".ds-promo-banner-new__heading, .ds-promo-banner-new__description"
    );
    const creativeTexts = Array.from(creativeElements)
        .map((el) => el.textContent?.trim().replace(/\s+/g, " ") || "")
        .filter((text) => text.length > 0);
    return creativeTexts.join("; ");
}

const dataLayerHomepageBanners = () => {
    const banners = document.querySelectorAll<HTMLElement>(".hero-card");

    for (const banner of banners) {
        const bannerId = banner.querySelector<HTMLElement>(".hero-card__inner").dataset.aCodename;
        const bannerText = banner.querySelector<HTMLElement>(".hero-card__title").innerText;
        const bannerOrder = (Array.from(banners).indexOf(banner) + 1).toString();

        dataLayerHPBannerImpression(bannerId, bannerText, bannerOrder);

        banner.addEventListener("click", () => {
            dataLayerHPBannerClick(bannerId, bannerText, bannerOrder);
        });
    }

    const dsBanners = document.querySelectorAll<HTMLElement>(".ds-promo-banner-new");

    for (const banner of dsBanners) {
        const bannerId = banner.querySelector<HTMLElement>(".ds-promo-banner-new__inner").dataset.aCodename;
        const bannerText = extractCreativeFromBanner(banner);
        const bannerOrder = (Array.from(dsBanners).indexOf(banner) + 1).toString();

        dataLayerHPBannerImpression(bannerId, bannerText, bannerOrder);

        banner.addEventListener("click", () => {
            dataLayerHPBannerClick(bannerId, bannerText, bannerOrder);
        });
    }
};

$(() => {
    dataLayerHomepage();
    dataLayerHomepageBanners();
});
